"use client";
import React, {useEffect, useState} from "react";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import {Button, FontIcon, Toast} from "@/app/_components";
import $http from "@/app/_api";
import {getUserId} from "@/app/utils/auth";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import {useAppDispatch, useAppSelector} from "@/app/storeHooks";
import {getUserInfoAsync} from "@/app/userSliceAPI";
import {hideForceLoading, showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";
import {selectUserInfo} from "@/app/userSlice";
import styles from "./newcomerGiftPack.module.css";
import GameTrack from "@/Core/GameTrack";

interface NewcomerGiftPackDialogProps extends SDialogProps {
    gcBonus: number;
    scBonus: number;
}

export const NewcomerGiftPackDialogFC: React.FC<NewcomerGiftPackDialogProps> = (props) => {
    const { fcKey, gcBonus, scBonus, isOpen, onClose } = props;

    const {closeDialog}=useDialogMethods(fcKey);

    const dispatch = useAppDispatch();
    const userInfo = useAppSelector(selectUserInfo);

    // const [gcBonus, setGcBonus] = useState<number>(0);
    // const [scBonus, setScBonus] = useState<number>(0);

    if (!isOpen) return null;

    useEffect(() => {
        return () => {
            // if (!userInfo.isGuide) {
            //     GameTrack.closeNewbieReward(2)
            // }
        }
        // getRewardsData();
    }, [userInfo]);

    // const getRewardsData = async () => {
    //     const data = await $http.Rewards.getRewardsConfig({rewardSource: 102});
    //     const { gcBonus, scBonus } = data;
    //     // setGcBonus(gcBonus);
    //     // setScBonus(scBonus);
    //     return data;
    // }

    const onCloseDialog = () => {
        closeDialog();
        onClose?.();
    }

    const getRewards = async () => {
        showForceLoading();
        const result = await rewardsApply();
        if (!result) {
            hideForceLoading();
            Toast.show("Claim failed: Network fluctuation. Please try again.");
            return;
        }
        hideForceLoading();
        onCloseDialog();
        await dispatch(getUserInfoAsync());
    }

    const handleCloseDialog = () => {
        GameTrack.closeNewbieReward(2)
        getRewards();
    }

    const rewardsApply = async () => {
        const data = await $http.Rewards.rewardsApply({rewardSource: 102, userId: getUserId()});
        if (!data) {
            return false;
        }
        return data;
    }

    const onClickClaim = async () => {
        GameTrack.clickNewbieReward();
        getRewards();
    };

    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Full"
            title={<span>{'\n\n\n'}</span>}
            onClose={onClose}
        >
            <section className={`${styles.layer}`}></section>
            <section className={`${styles.wrapper} h-v-center`}>
                <section className={styles.content}>
                    <div className={styles.icon_close} onClick={handleCloseDialog}>
                        <FontIcon icon="s-close" style={{ color: "#DC5AEB" }} />
                    </div>
                    <h4>WELCOME</h4>
                    <h1>Go Go Gold</h1>
                    <div className={styles.main}>
                        <img className={styles.main_icon} src="/img/ico_gift_newcomer.webp" alt="" />
                        <div className={styles.text_claim}>Claim your</div>
                        <div>
                            <img className={styles.icon_gold} src="/img/ico_gc.png" alt="" />
                            <span className={styles.text_num}>{gcBonus/1000}K</span>
                            <span className={styles.text_plus}>+</span>
                            <img className={styles.icon_gold} src="/img/ico_sc.png" alt="" />
                            <span className={styles.text_num}>{scBonus}</span>
                        </div>
                    </div>
                    <Button
                        color="#33D24A"
                        style={{
                            color: "#fff",
                            width: "5rem",
                            height: "1.1rem",
                            fontSize: ".6rem",
                            fontWeight: 900,
                        }}
                        onClick={onClickClaim}
                    >
                        Claim
                    </Button>
                </section>
            </section>
        </SDialogFC>
    );
};
